import { Area, AreaCreate, AreaDelete } from '@src/main/modules/common/area/domain/Area';
import { AreaRepository } from '@src/main/modules/common/area/domain/AreaRepository';
import { useAreaUseCases } from '@src/main/ui/providers/area/hooks/useAreaUseCases';
import { FC, PropsWithChildren, createContext, useContext, useMemo } from 'react';

interface ContextState {
  areas?: Area[];
  addArea: (area: AreaCreate) => Promise<void>;
  deleteArea: (area: AreaDelete) => Promise<void>;
}

const AreaContext = createContext<ContextState>({} as ContextState);

interface Props {
  areaRepository: AreaRepository;
}

export const AreaContextProvider: FC<PropsWithChildren<Props>> = ({ children, areaRepository }) => {
  const { areas, addArea, deleteArea } = useAreaUseCases(areaRepository);

  const values = useMemo(
    () => ({
      areas,
      addArea,
      deleteArea,
    }),
    [areas, addArea, deleteArea],
  );

  return <AreaContext.Provider value={values}>{children}</AreaContext.Provider>;
};

export const useAreaContext = (): ContextState => useContext(AreaContext);
